const DEFAULT_AVATAR_NEW =
  'https://lib.socialchorus.com/mojo/public/default_avatar_new.png';

export default DEFAULT_AVATAR_NEW;
